import { render, staticRenderFns } from "./EmployeeSyncSettings.vue?vue&type=template&id=766fa576&scoped=true&"
import script from "./EmployeeSyncSettings.vue?vue&type=script&lang=js&"
export * from "./EmployeeSyncSettings.vue?vue&type=script&lang=js&"
import style0 from "./EmployeeSyncSettings.vue?vue&type=style&index=0&id=766fa576&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "766fa576",
  null
  
)

export default component.exports